import createIcon from '../../createIcon';

/**
 * @component @name AutofpsSelect
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuMDMgNS44SDExLjk3TDEwLjk1IDguNjlIMTMuMDVMMTIuMDMgNS44WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTUgMTYuNUgzVjIxLjVINVYxNi41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEyIDE0LjVDMTUuMzEgMTQuNSAxOCAxMS44MSAxOCA4LjVDMTggNS4xOSAxNS4zMSAyLjUgMTIgMi41QzguNjkgMi41IDYgNS4xOSA2IDguNUM2IDExLjgxIDguNjkgMTQuNSAxMiAxNC41Wk0xMS4zNyA0LjVIMTIuNjJMMTUuMjUgMTEuNUgxNC4wNEwxMy40MSA5LjcxSDEwLjU4TDkuOTYgMTEuNUg4Ljc0TDExLjM3IDQuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik05IDE2LjVIN1YyMS41SDlWMTYuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMyAxNi41SDExVjIxLjVIMTNWMTYuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMSAxNi41SDE1VjIxLjVIMjFWMTYuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AutofpsSelect = createIcon('AutofpsSelect', [
  ['path', { d: 'M12.03 5.8H11.97L10.95 8.69H13.05L12.03 5.8Z', key: '1hxjx0' }],
  ['path', { d: 'M5 16.5H3V21.5H5V16.5Z', key: '1s2ned' }],
  [
    'path',
    {
      d: 'M12 14.5C15.31 14.5 18 11.81 18 8.5C18 5.19 15.31 2.5 12 2.5C8.69 2.5 6 5.19 6 8.5C6 11.81 8.69 14.5 12 14.5ZM11.37 4.5H12.62L15.25 11.5H14.04L13.41 9.71H10.58L9.96 11.5H8.74L11.37 4.5Z',
      key: '1wesyx',
    },
  ],
  ['path', { d: 'M9 16.5H7V21.5H9V16.5Z', key: 'o9h6d8' }],
  ['path', { d: 'M13 16.5H11V21.5H13V16.5Z', key: '1avldh' }],
  ['path', { d: 'M21 16.5H15V21.5H21V16.5Z', key: '1e3kek' }],
]);

export default AutofpsSelect;
